import Container from "@components/Container/Container";

/**
 * Component to render Judging Panel on SIA homepage
 */
const SIAJudgingPanel = (): React.ReactElement => {
  return (
    <Container>
      <div className="mb-11 w-full text-center lg:mb-14">
        <div className="flex flex-col py-3 pb-0 text-center font-public-sans leading-[1.4] text-gray-850 lg:flex-row lg:pb-3">
          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Dr Amy Khor</strong>
              <br />
              Chairman of the Judging Panel
            </p>
          </div>

          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Ms Chen Huifen</strong>
              <br />
              Editor
              <br />
              The Business Times
            </p>
          </div>

          <div className="w-full p-3 pb-0 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Geoffrey Yeo</strong>
              <br />
              Assistant Managing Director, Capabilities, Urban
              <br />
              Systems &amp; Solutions, Enterprise Singapore
            </p>
          </div>
        </div>

        <div className="flex flex-col py-3 pb-0 text-center font-public-sans leading-[1.4] text-gray-850 lg:flex-row lg:pb-3">
          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Professor Lawrence Loh</strong>
              <br />
              Director, Centre for Governance and Sustainability
              <br />
              Professor, Strategy and Policy
              <br />
              NUS Business School
              <br />
              National University of Singapore
            </p>
          </div>

          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Ms Eliza Tan</strong>
              <br />
              Senior Vice President
              <br />
              Head, IPO Admissions
              <br />
              Head, Sustainable Development Office
            </p>
          </div>

          <div className="w-full p-3 pb-0 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Tan Swee Yiow</strong>
              <br />
              President of REDAS
              <br />
              Real Estate Developers&apos;s Association of Singapore
              <br />
              (REDAS)
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-center py-3 text-center font-public-sans leading-[1.4] text-gray-850 lg:flex-row">
          <div className="w-full p-3 pb-0 lg:w-1/3 lg:py-0">
            <p>
              <strong>Ms Melissa Kwee</strong>
              <br />
              Director, Pontiac Land Group
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SIAJudgingPanel;
